import { FC, useEffect, useState } from 'react';
import 'twin.macro';
import { Link } from 'gatsby';
import { useMediaQuery } from '@mui/material';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import { styled, useTheme } from '@mui/material/styles';

import Menu from './Menu';
import MenuMobile from './MenuMobile';
import useMainIsTop from 'src/hooks/useIsTop';
// import Banner from '../Banner';

const Root = styled(AppBar)<{ top?: number }>(({ theme, top }) => ({
  backgroundColor: 'transparent',
  boxShadow: 'none',
  top: `${top ? -top : 0}px`,
}));

const StyledAppBar = styled(AppBar)<{ mode: 'transparent' | 'fill' }>(
  ({ theme, mode }) => ({
    boxShadow: '0 0 black',
    padding: '28px 0',
    backgroundColor:
      mode === 'fill' &&
      typeof window !== 'undefined' &&
      window.location.pathname.length < 2
        ? `rgba(255,255,255,0.3)`
        : 'transparent',
    color: theme.palette.common.black,
    backdropFilter: mode === 'fill' ? 'saturate(180%) blur(20px)' : 'null',
    position: 'relative',
    // top: '100px',
    transition:
      'transform 0.5s ease-out, box-shadow 0.3s ease-out, background-color 0.3s ease-out;',

    [theme.breakpoints.down('lg')]: {
      padding: '18px 0',
      width: '100%',
      // top: '60px',
    },
  })
);

const Logo = styled('img')(({ theme }) => ({
  width: 186,
  height: 40,
  [theme.breakpoints.down('md')]: {
    width: 160,
    height: 36,
  },
}));

const Header: FC = () => {
  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const { isTop } = useMainIsTop();

  const [scrollTop, setScrollTop] = useState(
    typeof window !== 'undefined' ? window.pageYOffset : 0
  );

  const shouldUseWhiteLogo = typeof window !== 'undefined' && isTop && window.location.pathname.length < 2;

  useEffect(() => {
    const handleScroll = () => {
      setScrollTop(Math.min(window.pageYOffset, 100)); // 100px : 배너 사이즈
    };

    document.addEventListener('scroll', handleScroll);
    return () => document.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Root>
      {/*
       * 추후 배너 이용할 일 있을 때 아래 순서대로 적용
       * 1. 아래 배너 컴포넌트 주석 해제
       * 2. /src/components/Banner/index.tsx 파일에서 배너 디자인 수정
       * 3. 상단 Header 고정을 위해 <Root top={scrollTop}> 으로 props 전달
       * 4. 만일 배너 디자인이 변경되어 높이가 변경될 경우 setScrollTop() 함수의 100px 값을 변경
       */}
      {/* <Banner /> */}

      <StyledAppBar mode={isTop ? 'transparent' : 'fill'}>
        <Container>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item>
              <Link to="/">
                {shouldUseWhiteLogo ? (
                  <Logo
                    src="/logos/img-header-logo-white.svg"
                    alt="hyperconnect career"
                  />
                ) : (
                  <Logo
                    src="/logos/img-header-logo.svg"
                    alt="hyperconnect career"
                  />
                )}
              </Link>
            </Grid>
            <Grid item>
              {lgUp ? (
                <Typography component="span" variant="h3">
                  <Menu />
                </Typography>
              ) : (
                <MenuMobile />
              )}
            </Grid>
          </Grid>
        </Container>
      </StyledAppBar>
    </Root>
  );
};

export default Header;
